import { SLIDE_COUNT } from "../../../engine/state";

/**
 * The talk before round 1: a few slides on the wall, moved from the owner's phone (the
 * `slides.set` event). The engine knows how many there are; what is on them lives in
 * views/projector/Slides.tsx, and their titles here, for the owner's card on the Rounds tab.
 */
export const SLIDE_TITLES: readonly string[] = [
  "BDayminton",
  "The day",
  "Getting in",
  "A round",
  "Coming and going",
  "While you rest",
  "Any questions?",
];

if (SLIDE_TITLES.length !== SLIDE_COUNT) throw new Error("the slide titles and SLIDE_COUNT disagree");

export { SLIDE_COUNT };
